import React, { Component, Fragment } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { reduxForm, Field, change } from "redux-form";
import { register, checkExists, resetExistsCheck, subscribeToNewsletter } from "../actions/accountActions";
import FormField from "../components/FormField";
import Alert from "../components/Alert";
import { Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router";
import { required, email } from 'redux-form-validators'
import UserInfoFields from "../components/UserInfoFields"
import { withTranslation } from 'react-i18next';
import { utils } from "../common/utils";
import RepresentativePicker from './RepresentativePicker';
import SocialAccounts from "../components/SocialAccounts";
import ExtendedLink from "../components/ExtendedLink";
import * as urls from "../common/urls"
import { SuppliersEnum } from "../common/enums";

const styles = { select: { width: '100%' } };


class RegisterForm extends Component {

    constructor(props) {
        super(props);
        const { user, settings } = props;
        this.state = {
            hasRepresentative: !settings.allowRegisterByEPR, selectedRepresentative: null, isChecked: (user && user.isAuthenticated) ? user.isNewsletterSubscriber : true,
            isReferralProgramNotActive: false, isLoadedReferralProgram: false
        };
        this.subscribeToNewsletterHanlder = this.subscribeToNewsletterHanlder.bind(this); // set this, because you need get methods from CheckBox 
    }

    componentDidMount() {
        const { settings, history, consultant, user } = this.props;

        //allowRegister setting flag is used as an indicator to differentiate between normal suppliers register flow and other suppliers nearby consultant registiration flow */}
        // so if no nearby isn't selected we force return to login, this case will happen if user puts /register in the url   
        if (!settings.allowRegister && !consultant && settings.isPersonalisedSite !== true) {
            history.push(`${settings.baseUrl}login${history.location.search}`);
        }
        if (settings.isPersonalisedSite === true && user.representative) {
            this.setState({ hasRepresentative: true, selectedRepresentative: { ...user.representative, pictureUrl: user.representative.imageUrl } });
        }
        const referralCode = this.props.match.params.referralCode
        if (referralCode) {
            axios.get(urls.GET_ACTIVE_REFERRAL_PROGRAM_SETTING_URL, { headers: { "Content-Type": "application/json" } }).then(response => {
                if (response.status === 200 && response.data) {
                    const referralCodeProgramId = referralCode.slice(referralCode.indexOf('_') + 1)
                    if (+response.data.id !== +referralCodeProgramId) this.setState({ isReferralProgramNotActive: true })
                    this.setState({ isLoadedReferralProgram: true })
                }
                else this.setState({ isReferralProgramNotActive: true, isLoadedReferralProgram: true })
            })
        }

        if (consultant) {
            this.onRepresentativeSelected(consultant);
        }
    }

    onRepresentativeSelected(selectedRepresentative) {
        this.setState({ selectedRepresentative: selectedRepresentative });
    }

    onResetSelectedRepresentative(selectedRepresentative) {
        this.setState({ selectedRepresentative: null });
    }


    onUserDeclaresRepresentative(e) {
        if (e.target.id === "chkHasRepresentative") {
            this.setState({ hasRepresentative: e.target.checked === true });
        } else if (e.target.id === "chkNoRepresentative") {
            this.setState({ hasRepresentative: e.target.checked === false });
        }

    }


    registerSubmitHanlder(values) {
        //  this.setState({ isRegistering: true });
        const { user } = this.props;
        values.representative = this.state.selectedRepresentative ? this.state.selectedRepresentative : user.representative;
        values.locale = user.locale;
        return this.props.register(values, !this.state.isReferralProgramNotActive ? this.props.match.params.referralCode : null).then((response) => {

            if (response.value.data.success === true && this.props.match.params.referralCode && !this.state.isReferralProgramNotActive && response.value.data.referralDiscountCode) {
                this.setState({ discountCode: response.value.data.referralDiscountCode });
            }
            utils.scrollTop();
        }, (error) => {
            console.log(error);
        });
    }

    customerExistsSubmitHanlder(values) {
        //this.setState({ firstName: values.firstName, lastName: values.lastName, email: values.email, postCode: values.postCode });
        this.setState({ email: values.email });
        const { user } = this.props;
        user.email = values.email;
        return this.props.checkExists(values, !this.state.isReferralProgramNotActive ? this.props.match.params.referralCode : null).then((response) => {
            // console.log(response)
            //  this.setState({ isFirstRender: false });
            utils.scrollTop();
        }, (error) => {
            console.log(error);
        });
    }

    componentWillUnmount() {
        this.props.resetExistsCheck();
    }

    onGoogleAddressChange(mappedAddress) {
        this.props.change("register", "address1", mappedAddress.address1);
        this.props.change("register", "address2", mappedAddress.address2);
        this.props.change("register", "address3", mappedAddress.address3);
        this.props.change("register", "address4", mappedAddress.address4);
        this.props.change("register", "postCode", mappedAddress.postCode);

    }
    subscribeToNewsletterHanlder() {
        let newCheckStatus = !this.state.isChecked;
        this.setState({ isChecked: newCheckStatus }, () => {
            const { user } = this.props;
            return this.props.subscribeToNewsletter({ customerId: user.id, shouldSubscribe: this.state.isChecked }).then((response) => {
                const { t } = this.props;
                showSuccess(t("Newsletter"), (this.state.isChecked ? t("Subscribed successfully") : t("Unsubscribe successful")), Icons.APP);
            }, (error) => {
                console.log(error);
            });
        });

    }

    render() {
        const { t, handleSubmit, user, settings, submitting } = this.props;
        const showNewsLetterSignup = settings.showNewsLetterSignup;
        const hasRepresentative = this.state.hasRepresentative, selectedRepresentative = this.state.selectedRepresentative,
            showUserInfoFields = settings.isPersonalisedSite === true || (hasRepresentative === false) || (hasRepresentative && selectedRepresentative !== null),
            showRepAvatar = hasRepresentative && selectedRepresentative !== null, //settings.isPersonalisedSite !== true &&  removed to make the default rep vis
            showRepPicker = settings.isPersonalisedSite !== true && selectedRepresentative === null,
            representativePictureUrl = showRepAvatar && selectedRepresentative.pictureUrl
                ? selectedRepresentative.pictureUrl :
                (showRepAvatar && selectedRepresentative.fullPictureUrl ? selectedRepresentative.fullPictureUrl : settings.defaultImageUrl);
        if (user.isAuthenticated) {
            return <Redirect to={settings.baseUrl} />;
        }

        if (user.isCustomerExists === undefined) {
            return (<div className="row padding-top-3x">
                {this.state.isReferralProgramNotActive && this.state.isLoadedReferralProgram &&
                    <Alert type="warning" title={t("Referral Program")} msg={t("Unfortunately, referral program isn't available. You can still continue and checkout our great products!")}></Alert>}
                <div className="col-md-12">

                    <div className="padding-top-3x hidden-md-up"></div>

                    <h3 className="margin-bottom-1x">{t("No Account? Register")}</h3>
                    <p>{t("Before you register, Lets check if you already have an account with us")} </p>
                    <form
                        className="row"
                        method="post"
                        autoComplete="off"
                        onSubmit={handleSubmit(this.customerExistsSubmitHanlder.bind(this))} >
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label htmlFor="email">{t("Email")}</label>
                                <Field
                                    className="form-control"
                                    type="text"
                                    name="email"
                                    icon="icon-mail"
                                    autoComplete="off"
                                    component={FormField}
                                    placeholder={t("Email")}
                                    validate={[required({ msg: t("is required") }), email({ msg: t("is invalid email") })]}
                                />
                                <div className="col-12 text-center text-sm-right">
                                    <button className="btn btn-primary margin-bottom-none" type="submit" disabled={submitting}>{t("Check")}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>);
        }

        if (user.isCustomerExists === true) {
            return (<Alert type="warning" title={t("Register")} msg={t("Looks like you might be already registered")}>
                <br />
                <ExtendedLink className="btn btn-primary font-white" to={`${settings.baseUrl}forgot-password`}>
                    {t("Forgot password?")}
                </ExtendedLink>
            </Alert>);
        }


        if (user.isAccountCreated) {
            const { settings } = this.props;
            if (window.fbq) {
                window.fbq('track', 'CompleteRegistration', { currency: settings.isoCurrencySymbol, value: '0.00' });
            }
            if (window.vgo) {
                window.vgo('update');
                window.vgo('process');
            }
            return (
                <Alert type="success" title={t("Register")} msg={t("Your account was created successfully. please check your email for your login information.")}>  <ExtendedLink className="btn btn-primary font-white" to={`${settings.baseUrl}login`}>
                    {t("Login")}
                </ExtendedLink>
                    {this.props.match.params.referralCode && !this.state.isReferralProgramNotActive && <p className="text-primary">{t("You have been succesfully registered in the referral program. ")}{this.state.discountCode && <>{t("This is your discount code ")}<span className="text-warning text-bold">{this.state.discountCode}</span></>}</p>}
                </Alert>);

        }


        return (
            <div className="row padding-top-3x">
                <div className="col-md-12">
                    <div className="hidden-md-up"></div>
                    {settings.isPersonalisedSite === true &&
                        <Fragment>
                            <h3 className="margin-bottom-1x">{t("No Account? Register")}</h3>
                            <p>{t("Registration takes less than a minute but gives you full control over your orders")}</p>
                        </Fragment>}

                    <form
                        method="post"
                        onSubmit={handleSubmit(this.registerSubmitHanlder.bind(this))} >
                        {showRepPicker && !settings.allowRegisterByEPR &&
                            <div className='row'>
                                <div className="col-md-6 mx-md-auto justify-content-center text-center pt-2">
                                    <h3>{t("Do you have a Representative?")} </h3>
                                    <p>
                                        {t("RepresentativeDescMsg")}
                                    </p>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox custom-control-inline">
                                            <input id='chkHasRepresentative' className="custom-control-input" type="checkbox" checked={this.state.hasRepresentative} onChange={this.onUserDeclaresRepresentative.bind(this)} />
                                            <label className="custom-control-label" htmlFor='chkHasRepresentative'>{t("Yes")}</label>
                                        </div>
                                        <div className="custom-control custom-checkbox custom-control-inline">
                                            <input id='chkNoRepresentative' className="custom-control-input" type="checkbox" checked={!this.state.hasRepresentative} onChange={this.onUserDeclaresRepresentative.bind(this)} />
                                            <label className="custom-control-label" htmlFor='chkNoRepresentative'>{t("No")}</label>
                                        </div>
                                    </div>
                                    {this.state.hasRepresentative &&
                                        <div className="form-group text-left">
                                            <label htmlFor="representativeId">{t("Choose Your Representative")} </label>
                                            <RepresentativePicker name="representativeId" isMulti={false} style={styles.select} onChange={this.onRepresentativeSelected.bind(this)} placeholder={t("Type your representative name")} />
                                        </div>}
                                </div>
                            </div>
                        }
                        {showRepAvatar &&
                            <div className='float-md-left mb-2'>
                                <div className="card text-center align-items-center">
                                    {representativePictureUrl && <img className="card-img-top epr-mini-profile-img" src={representativePictureUrl} alt="" />}
                                    <div className="card-body">
                                        <h5 className="card-title mb-2">{selectedRepresentative.name}</h5>
                                        <p>{t("is your Representative")} </p>
                                        <div className="social-bar">
                                            <SocialAccounts shape="circle" representative={selectedRepresentative} />
                                        </div>
                                        {settings.allowRegister && settings.isPersonalisedSite !== true &&
                                            <button className="btn btn-primary margin-bottom-none" onClick={this.onResetSelectedRepresentative.bind(this)}>{t("Change")}</button>}
                                        {!settings.allowRegister && settings.isPersonalisedSite !== true &&
                                            <button className="btn btn-primary margin-bottom-none" onClick={() => this.props.history.push(`${settings.baseUrl}login${this.props.history.location.search}`)}>{t("Change")}</button>}
                                    </div>
                                </div>
                            </div>
                        }

                        {showUserInfoFields &&
                            <div className='row'>
                                <UserInfoFields settings={settings} isProfile={false} onGoogleAddressChange={this.onGoogleAddressChange.bind(this)} />
                                <div className="col-12 text-center text-sm-right">
                                    {showNewsLetterSignup &&
                                        (<div className="d-inline-block mr-3">
                                            <input type="checkbox" className="mr-2" checked={this.state.isChecked} onChange={this.subscribeToNewsletterHanlder} />
                                            <label>{t("Subscribe me to Newsletter")}</label>
                                        </div>
                                        )}
                                    <button className="btn btn-primary margin-bottom-none" type="submit" disabled={submitting}>{t("Register")}</button>
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>
        );
    }
}

function validate(values, props) {
    const errors = {};
    const { t } = props;

    if (utils.isNullOrEmpty(values.password) !== false && utils.validations.isStrongPassword(values.password) === false) {
        errors.password = t("PasswordDesc");
    }
    if (values.password !== values.confirmPassword) {
        errors.password = t("your password and confirm password doesn't match");
        errors.confirmPassword = " ";
    }
    if (!values.mobile && !values.phone) {
        errors.phone = t("please enter a phone number or a mobile number.");
        errors.mobile = " ";
    }
    //else {
    //    if (values.mobile && !phoneNumber(values.mobile)) {
    //        errors.mobile = t("Invalid mobile number.");
    //    }
    //    if (values.phone && !phoneNumber(values.phone)) {
    //        errors.phone = t("Invalid phone number.");
    //    }
    //}
    return errors;
}

function mapStateToProps({ user, settings, consultant }, ownProps) {
    return { user, settings, consultant, ...ownProps };
}

RegisterForm = connect(mapStateToProps, { register, checkExists, resetExistsCheck, change, subscribeToNewsletter })(RegisterForm);

export default withTranslation()(withRouter(reduxForm({
    form: "register",
    validate
})(RegisterForm)));
